import { render, staticRenderFns } from "./Step2Album.vue?vue&type=template&id=48eb004a&scoped=true&"
import script from "./Step2Album.vue?vue&type=script&lang=js&"
export * from "./Step2Album.vue?vue&type=script&lang=js&"
import style0 from "./Step2Album.vue?vue&type=style&index=0&id=48eb004a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eb004a",
  null
  
)

export default component.exports